import { computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';
import LabelOrdenacao from './shared/LabelOrdenacao';

class OrdemPreSessao extends ReactComponent {
    textoAlternativoTooltip = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            textoAlternativoTooltip: observable,
            hasOrdem: computed,
            ordem: computed,
            hasTotal: computed,
            total: computed
        });
    }

    get hasOrdem() {
        return !!this.observableProps.ordem;
    }

    get ordem() {
        return this.hasOrdem ? this.observableProps.ordem : '';
    }

    get hasTotal() {
        return !!this.observableProps.total;
    }

    get total() {
        return this.hasTotal ? ` / ${this.observableProps.total}` : '';
    }

    render() {
        return (
            <LabelOrdenacao
                titulo={this.hasTotal ? 'Ordem pré-sessão / Total de processos' : 'Ordem pré-sessão'}
                conteudo={`${this.ordem}${this.total}`}
                circular={!this.hasTotal}
            />
        );
    }
}

export default inject('stores')(observer(OrdemPreSessao));
